import en from './en.json';
import ru from './ru.json';
import { i18n } from 'locales';

i18n.addResourceBundle('en', 'marketplace', en, true);
i18n.addResourceBundle('ru', 'marketplace', ru, true);
